var _path, _path2, _g, _path3, _path4, _path5, _g2, _circle, _path6, _circle2, _g3, _path7, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1086,
    viewBox: "0 0 1000 1086",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380.163 458.405C380.363 469.07 377.27 489.636 377.373 496.637M377.373 496.637C397.946 495.159 424.408 494.026 454.278 497.531C484.148 501.037 490.572 501.242 500.419 505.619C524.539 514.117 526.191 515.287 531.13 517.976M377.373 496.637L382.73 564.46M531.13 517.976C533.816 518.846 685.481 502.945 685.481 502.945L804.675 489.393L832.702 491.439M531.13 517.976C518.898 539.44 501.191 551.529 477.279 568.388M910.082 561.148L895.195 529.717L877.962 511.601M690.935 578.867L714.913 561.062L760.371 569.1L799.666 633.331L719.888 694.94L650.482 748.539M690.935 578.867L669.06 577.27L582.927 570.982C576.004 570.858 539.661 575.731 526.968 574.989C514.276 574.248 507.635 575.266 474.332 571.147M690.935 578.867L584.49 662.542M474.332 571.147L382.73 564.46M474.332 571.147L477.279 568.388M382.73 564.46C390.444 571.767 420.514 611.723 420.514 611.723M382.73 564.46L222.741 694.388M420.514 611.723L477.279 568.388M420.514 611.723L446.797 646.009M506.48 723.867L573.895 807.683M506.48 723.867L584.49 662.542M506.48 723.867L430.734 782.398M506.48 723.867L463.497 667.795M573.895 807.683L650.482 748.539M573.895 807.683L670.406 925.99M573.895 807.683L496.002 867.406M584.49 662.542L650.482 748.539M650.482 748.539L718.322 827.77L670.406 925.99M670.406 925.99L577.475 975.175L496.002 867.406M496.002 867.406L430.734 782.398M496.002 867.406L419.669 933.986M430.734 782.398L385.139 729.17M430.734 782.398L361.725 852.21M385.139 729.17L463.497 667.795M385.139 729.17L373.179 714.136M463.497 667.795L446.797 646.009M446.797 646.009L373.179 714.136M373.179 714.136L301.193 777.662M301.193 777.662L361.725 852.21M301.193 777.662L222.741 694.388M361.725 852.21L419.669 933.986M419.669 933.986L437.488 953.493M222.741 694.388L158.248 740.254L95.9866 670.301L167.502 613.484M376.99 454.802C428.534 457.806 453.768 459.717 494.568 463.385L695.26 434.878L815.872 411.315L853.362 462.603M853.362 462.603L832.702 491.439M853.362 462.603L860.729 493.485L832.702 491.439M332.36 557.809L150.073 503.646L111.931 536.601L167.502 613.484M188.083 641.959L167.502 613.484",
    stroke: "url(#paint0_linear_165_56)",
    strokeOpacity: 0.4,
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M380.267 476.147L439.432 483.124M454.856 497.584L457.092 521.888M524.737 518.106L457.092 521.888M585.731 515.664L580.214 486.964L649.557 488.962L674.762 544.039L535.433 554.014M437.133 627.588L462.439 610.511L461.988 581.855L602.742 596.36M485.103 535.408L481.707 533.769M457.092 521.888L481.707 533.769M383.867 524.398L431.895 526.299L474.839 550.519L481.707 533.769M403.161 596.371L347.864 646.907L371.078 669.645L425.617 625.916M431.779 640.645L397.48 667.253M573.851 616.543L598.562 648.03M573.851 616.543L631.632 576.177M573.851 616.543L525.494 652.638M451.192 618.101L499.899 682.816M491.233 634.521L539.94 699.236M388.557 547.675L413.018 547.538M750.222 565.832L723.645 588.489M663.088 681.608L643.913 656.459L697.068 611.146M663.088 681.608L722.736 632.857M663.088 681.608C641.132 715.312 665.685 716.31 659.499 712.676M663.088 681.608L745.893 780.406M722.736 632.857L697.068 611.146M722.736 632.857L739.165 652.305M697.068 611.146L723.645 588.489M723.645 588.489L767.819 632.025L739.165 652.305M739.165 652.305L703.104 680.732L686.285 662.65M541.512 759.873C544.457 758.641 572.047 737.484 585.473 727.059L619.201 766.312L588.228 792.25L537.379 732.758M430.313 688.852L449.688 711.033M449.688 711.033L458.969 688.401L479.015 713.908L432.911 751.945L449.688 711.033ZM449.688 711.033L417.888 731.548M517.897 743.072L472.307 782.336M472.307 782.336L502.754 817.192L505.76 772.667M472.307 782.336L455.637 790.752L493.473 839.823L529.757 805.895L505.76 772.667M472.307 782.336L505.76 772.667M472.307 782.336L457.24 767.005M505.76 772.667L484.018 741.38C453.495 715.402 443.121 689.984 386.965 705.294M271.383 662.318C279.998 679.989 287.185 689.711 309.263 706.323L284.158 720.432C275.935 726.946 270.958 729.399 245.72 680.265L271.383 662.318ZM271.383 662.318C342.136 707.193 365.688 714.679 386.965 705.294M386.965 705.294C387.691 739.227 374.008 761.684 367.076 768.671L327.411 729.018L318.105 734.353L354.645 771.708L325.012 804.296L229.875 835.444L202.704 765.325M202.704 765.325L190.737 734.997M202.704 765.325L172.175 780.261L154.384 756.696L190.737 734.997M190.737 734.997C190.737 734.997 198.277 711.651 222.337 717.45C246.396 723.249 247.918 749.294 247.918 749.294C244.686 758.436 235.715 758.041 190.737 734.997ZM230.059 572.159L291.041 631.739L158.555 739.086L146.569 731.12L380.723 544.463L383.41 456.083L224.687 466.239L226.966 485.477L383.56 559.862M153.848 455.493L172.76 511.039L193.206 530.609L174.461 543.259M174.461 543.259L162.276 551.481L147.366 538.249L158.457 528.561L174.461 543.259ZM143.489 582.416C143.489 582.416 128.09 585.253 121.665 600.921C115.24 616.589 123.725 645.49 123.725 645.49L101.344 667.834C101.344 667.834 83.8468 670.827 87.6607 654.088C91.4745 637.349 155.388 600.514 155.388 600.514M430.049 860.589L407.208 869.176M267.355 885.386L311.622 958.448L370.225 929.605L308.949 843.467L282.103 856.861L311.034 905.332L407.208 869.176M267.355 885.386L342.897 857.388L317.159 823.446L248.224 855.17L267.355 885.386ZM391.148 853.788L423.148 830.304L457.033 871.654L416.015 887.372M416.015 887.372L407.208 869.176M416.015 887.372L424.901 910.336L505.278 895.344M505.278 895.344L549.32 887.129L578.295 930.533L508.733 953.866L475.973 897.375L505.278 895.344ZM505.278 895.344L516.943 933.845L535.699 987.294L659.842 915.166L634.931 886.647L678.291 862.738M618.524 864.667L660.701 836.205L644.807 815.452L682.074 789.044",
    stroke: "url(#paint1_linear_165_56)",
    strokeOpacity: 0.4,
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_165_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M590.762 431.445C845.332 383.869 805.947 387.989 923.337 353.662L1000 166.715C929.59 188.725 752.579 236.699 728.118 236.699C703.658 236.699 497.784 212.757 365.91 199.067L106.249 164.258L95.9004 445.557C280.235 441.297 378.372 439.64 590.762 431.445Z",
    fill: "#054ACA",
    fillOpacity: 0.4
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M344.272 184.827L316.989 183.073L66.7356 142.618L116.598 30.6628L354.621 43.834L344.272 184.827ZM344.272 184.827L508.912 195.413L516.438 195.897M603.933 201.523L741.29 210.356L786.448 200.549M603.933 201.523V120.98L568.182 56.0645L497.622 43.834L508.912 101.223V142.618L516.438 195.897M603.933 201.523L516.438 195.897M786.448 200.549L927.568 169.901L873.002 43.834L708.362 70.1765C731.568 108.393 779.674 187.971 786.448 200.549Z",
    stroke: "url(#paint2_linear_165_56)",
    strokeOpacity: 0.5,
    strokeWidth: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.429 83.2501L367.018 89.4002L362.033 180.904L309.43 182.72L309.023 148.998L422.834 79.7504L507.086 94.9809L508.608 121.026L581.858 135.811L585.546 173.93L606.324 175.333L604.803 160.473M604.803 160.473L601.653 129.693L648.388 139.707L650.022 172.916L604.803 160.473ZM628.906 150.021L763.782 210.415",
    stroke: "#054ACA",
    strokeOpacity: 0.2,
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.632 774.869L446.555 646.988L383.495 565.203L378.842 497.201L412.408 494.696",
    stroke: "#054ACA",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_165_56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 379.289,
    cy: 561.621,
    r: 21.864,
    transform: "rotate(22.2976 379.289 561.621)",
    fill: "#054ACA"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 379.289,
    cy: 561.621,
    r: 30.4112,
    transform: "rotate(22.2976 379.289 561.621)",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M833.333 189.634L740.191 210.108L515.196 194.439L508.356 143.557L508.08 94.5522L436.789 81.6142",
    stroke: "#0059FF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 838.537,
    cy: 186.879,
    r: 33.173,
    transform: "rotate(22.2976 838.537 186.879)",
    fill: "#0059FF",
    fillOpacity: 0.25
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_165_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M816.846 195.547C815.959 195.452 815.63 194.333 816.325 193.774L847.646 168.552C848.351 167.984 849.388 168.57 849.264 169.467L846.968 186.127C846.929 186.412 847.014 186.699 847.201 186.917L856.819 198.072C857.412 198.759 856.858 199.816 855.956 199.719L816.846 195.547Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M461.05 94.0081C452.517 114.816 428.732 124.766 407.924 116.234C387.117 107.701 377.166 83.9157 385.699 63.1082C394.232 42.3006 418.017 32.35 438.824 40.8827C459.632 49.4155 469.582 73.2006 461.05 94.0081Z",
    fill: "#034EDA",
    fillOpacity: 0.33,
    stroke: "white",
    strokeWidth: 3
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_165_56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 422.963,
    cy: 77.5743,
    r: 21.864,
    transform: "rotate(22.2976 422.963 77.5743)",
    fill: "#054ACA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_165_56",
    x: 95.9004,
    y: 164.258,
    width: 904.099,
    height: 285.299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_165_56"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_165_56",
    x: 309.419,
    y: 495.751,
    width: 139.74,
    height: 139.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0211112 0 0 0 0 0.290806 0 0 0 0 0.791667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_165_56"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_165_56",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.177917 0 0 0 0 0.508333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_165_56"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_165_56",
    x: 804.951,
    y: 155.328,
    width: 63.1143,
    height: 53.3979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_165_56"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_165_56",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_165_56",
    x: 353.093,
    y: 11.7046,
    width: 139.74,
    height: 139.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0211112 0 0 0 0 0.290806 0 0 0 0 0.791667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_165_56"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_165_56",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_165_56",
    x1: 528.421,
    y1: 390.332,
    x2: 486.216,
    y2: 968.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054ACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054ACA",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_165_56",
    x1: 510.72,
    y1: 432.028,
    x2: 297.26,
    y2: 952.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054ACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054ACA",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_165_56",
    x1: 497.152,
    y1: 30.6628,
    x2: 497.152,
    y2: 210.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054ACA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054ACA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.c9afc71ce9f532e8996f9f4a9c662bb0.svg";
export { ForwardRef as ReactComponent };